import React from 'react'
import './App.css'
import PaystackIntegration from './components/paystackIntegration'
 
function App() {
    return (
        <div className='App'>
            <PaystackIntegration/>
        </div>
    )
}
export default App